import { ExternalSystemType } from '@/graphql/generated/schemas'

export const CAMERA_SECRET_TEMPLATE = { rtspUsername: '', rtspPassword: '' }

export const PACS_SECRET_TEMPLATE = { username: '', password: '' }

export const EXTERNAL_ACCOUNT_SECRET_TEMPLATES: Record<
  ExternalSystemType,
  Record<string, string>
> = {
  [ExternalSystemType.ExacqvisionOnprem]: { username: '', password: '' },
  [ExternalSystemType.Ava]: {
    username: '',
    password: '',
    organization: '',
    region: '',
    url: '',
  },
  [ExternalSystemType.Avigilon]: {
    username: '',
    password: '',
    nonce: '',
    key: '',
    api_url: '',
    enable_ssl_check: '',
  },
  [ExternalSystemType.Verkada]: {
    api_key: '',
    expiration: '',
    permission: '',
  },
}

export const formatSecretTemplate = (obj: Record<string, string>): string =>
  JSON.stringify(obj, null, 2)
